import store from "../store";
import numberPluralization from "../helpers/numberPluralization";

export default function (key, count, group) {

  if(!key) return ''

  if(!group || !store.state.translates.hasOwnProperty(group)) {
    return key
  }

  key = key.toString()
  let result  = store.state.translates[group][key]

  if(!result) {
    process.env.NODE_ENV !== 'production' && throwErrorNotFound(group, key)
    return key
  }

  if(typeof count !== 'number') {
    return result
  }

  result = result.split(' | ')

  return result[numberPluralization(count)] || result[0]
}

function throwErrorNotFound(group, key) {
  // eslint-disable-next-line
 console.warn(`Translate not found [${group}/${key}]`)
}
